export default "__VITE_ASSET__7hWI3o12__"